import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import { VerifyNumberCommon } from 'pages/settings/ui/VerifyNumberCommon'

export const VerifyNumber = observer(() => {
  const {
    textEnableLandlineStore: { verifyNumberStore },
  } = useNewInboxStepsContext()
  const { disposeStep } = verifyNumberStore

  useEffect(() => {
    return () => {
      disposeStep()
    }
  }, [])

  return <VerifyNumberCommon store={verifyNumberStore} />
})
